/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 10:58:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 10:59:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReviewList/store/index.tsx
 */
import { createSlice } from '@reduxjs/toolkit';
import { unique } from '@/src/tools/helper';
import { getI18nFromGeneral } from '@/src/tools/tools';

const defaultState = {
  tabsActive: '',
  searchList: [],
  searchText: 0,
  filter: {},
  sort: {
    name: getI18nFromGeneral('general.hOCTitle.creatednewest'),
    key: 8,
    data: { field: 'createdDate', ascent: false },
  },
};
//TODO:Filter单选和多选的问题
const productReviewList = createSlice({
  name: 'productReviewList',
  initialState: defaultState,
  reducers: {
    searchList: (state, action) => {
      state.searchList.push(action.payload);
      state.searchList = unique(state.searchList); //去重
    },
    deleteSearch: (state, action) => {
      state.searchList.splice(action.payload, 1);
    },
    onFilter: (state, action) => {
      state.filter = action.payload;
    },
    eachOnFilter: (state, action) => {
      state.filter[action.payload.key] = action.payload.data;
    },
    filterClose: (state, action) => {
      state.filter[action.payload.key].splice(action.payload.index, 1);
    },
    sortBy: (state, action) => {
      state.sort = action.payload;
    },
    activeChange: (state, action) => {
      state.tabsActive = action.payload;
    },
    removeFilter: (state) => {
      state.searchList = [];
      state.filter = {};
    },
  },
});

export const {
  searchList,
  deleteSearch,
  onFilter,
  eachOnFilter,
  sortBy,
  activeChange,
  filterClose,
  removeFilter,
} = productReviewList.actions;

export default productReviewList.reducer;
